import React, { Component } from "react";

class CategoryV2 extends Component {
  render() {
    const { min_order, settings, language } = this.props;
    let min_order_text = min_order
      ? language === "english"
        ? ` Min Order ${min_order} ${settings.currency_english} `
        : ` الحد الأدنى ${min_order} ${settings.currency_local} `
      : null;

    return (
      <>
        <div className="col-6 px-2">
          <div
            onClick={() =>
              this.props.history.push(`/category/${this.props.slug}`)
            }
            className="pointer"
            style={{
              height: 216,
              borderRadius: 7,
              marginBottom: !settings.hide_grid_category_name ? 3 : 25,
              background: `url(${this.props.image}) no-repeat center center`,
              backgroundSize: settings?.fit_images_to_div
                ? "100% 100%"
                : "cover",
              border: "1px solid white",
              minHeight: 216,
            }}
          ></div>
          {/* {min_order_text && (
            <span
              style={{
                display: "block",
                color: "black",
                fontWeight: "bold",
                fontSize: "1.4rem",
                position: "relative",
                bottom: 210,
              }}
            >
              {min_order_text}
            </span>
          )} */}
          {!settings.hide_grid_category_name && (
            <>
              {" "}
              <p
                className={"mb-1 mt-2 "
                  .concat(language == "english" ? "text-left" : "text-right")
                  .concat(!!this.props.description ? "" : " mb-4")}
                style={{
                  marginLeft: language == "english" && 4,
                  marginRight: language == "arabic" && 4,
                  fontWeight: 600,
                  fontSize: "15.5px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  direction: language == "english" ? "ltr" : "rtl",
                }}
              >
                {this.props.name}
              </p>
              {!!this.props.description && (
                <p
                  className={"mb-4 cut-text-two-lines-grid-view ".concat(
                    language == "english" ? "text-left pl-1" : "text-right pr-1"
                  )}
                  style={{
                    fontSize: 14,
                    color: "#333333",
                    marginTop: 3,
                    marginBottom: 3,
                    height: 38,
                  }}
                >
                  {this.props.description}
                </p>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default CategoryV2;
